import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { autoinject, transient } from "aurelia-framework";

@autoinject
@transient()
export class MessageCentreIntroTab {

    public messageCenterHelpUrl: string;
    
    constructor(private configService: ConfigService){
        this.messageCenterHelpUrl = this.configService.config.urls.messageCenterHelpUrl;
    }
}